const DefaulterCheckRow = ({ data }) => {
  return (
    <>
      <tr className={`second-row relative`}>
        <td>{data?.tipoDeAcreedor ?? "N/A"}</td>
        <td>{data?.producto ?? "N/A"}</td>
        <td>{data?.importeDeLasOperaciones ?? "N/A"}</td>
        <td>{data?.situacion ?? "N/A"}</td>
        <td>{data?.numeroDeImpagados ?? "N/A"}</td>
        <td>{data?.importeImpagados ?? "N/A"}</td>
        <td>{data?.fechaPrimerImpago ?? "N/A"}</td>
        <td>{data?.fechaUltimoImpago ?? "N/A"}</td>
      </tr>
    </>
  );
};

export default DefaulterCheckRow;
